// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__WLrzo","header":"PatientBlock_header__3cNaW","label":"PatientBlock_label__2onuu","option":"PatientBlock_option__2I_43"};